import userauth from '~/helpers/userauth'

export default (to, from, next) => {
    var buildingId = to.params.buildingId;
    if (!userauth.hasBuildingAccess(buildingId, userauth.LEVEL_READ)) {
        next({name: 'dashboard'})
    } else {
        next()
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/building-read.js